import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, CardBox, EmptyState, Page } from '../../components';
import { retrieve } from '../../actions/organization-actions';
import { push } from '../../actions/nav-actions';
import { testRegex } from '../../utils';
import constants from '../../defaults/constants';
import { CSVLink } from 'react-csv';

import { getUserVisits } from '../../api';
import Loader from '../../components/Loader';
class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      surveyData: [],
    };
    this.renderChild = this.renderChild.bind(this);
    this.renderEmpty = this.renderEmpty.bind(this);
  }
  componentDidMount() {
    this.props.retrieve(this.props.user.token);
    this.getSurveys();
  }
  getSurveys = async () => {
    const survey = await getUserVisits(this.props.user.token);
    const formattedData = survey.map((item) => ({
      ...item,
      dateSignedUp: new Date(item.dateSignedUp).toLocaleDateString(),
    }));
    this.setState({ surveyData: formattedData });
  };
  renderEmpty() {
    return (
      <Loader />
    );
  }

  renderChild() {
    return [
      { Header: 'Name', accessor: 'name' },
      { Header: 'Email', accessor: 'email' },
      { Header: 'User Country', accessor: 'userCountry' },
      { Header: 'Organisation', accessor: 'organization' },
      { Header: 'Organization Country', accessor: 'organizationCountry' },
      { Header: 'Total Visits', accessor: 'totalVisits' },
      { Header: 'Visits Past Year', accessor: 'visitsPastYear' },
      { Header: 'Date Signed Up', accessor: 'dateSignedUp' },
    ];
  }

  handleDownload = () => {
    const data = this.state.surveyData.map(
      ({
        _id,
        name,
        email,
        userCountry,
        organization,
        organizationCountry,
        totalVisits,
        visitsPastYear,
        dateSignedUp,
      }) => ({
        _id,
        name,
        email,
        userCountry,
        organization,
        organizationCountry,
        totalVisits,
        visitsPastYear,
        dateSignedUp: new Date(dateSignedUp),
        // dateSignedUp: dateSignedUp,
      })
    );
    return data;
  };

  render() {
    let results = this.state.surveyData.filter((i) => testRegex(i.name, this.state.query));
    const csvHeaders = [
      { label: 'ID', key: '_id' },
      { label: 'Name', key: 'name' },
      { label: 'Email', key: 'email' },
      { label: 'User Country', key: 'userCountry' },
      { label: 'Organisation', key: 'organization' },
      { label: 'Organization Country', key: 'organizationCountry' },
      { label: 'Total Visits', key: 'totalVisits' },
      { label: 'Visits Past Year', key: 'visitsPastYear' },
      { label: 'Date Signed Up', key: 'dateSignedUp' },
    ];
    return (
      <Page title='User Activity Log'>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <CSVLink
            data={this.handleDownload()}
            headers={csvHeaders}
            filename={'survey_data.csv'}
            className='btn btn-info btn-block'
            style={{ width: '20%', marginBottom: 33 }}
          >
            Download CSV
          </CSVLink>
        </div>
        <CardBox>
          <Table id='survey' renderEmpty={this.renderEmpty} columns={this.renderChild()} data={results} />
        </CardBox>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  organizations: state.organizations,
});

const mapDispatchToProps = (dispatch) => ({
  retrieve(token) {
    dispatch(retrieve(token));
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Survey);



// WEBPACK FOOTER //
// ./src/routers/Survey/Survey.js